module.exports = __webpack_public_path__ + "static/media/217-Abspann_ID_7.4b8fd732.mp3";